import { c as _c } from "react/compiler-runtime";
import { PlanBookingType, PlanFrequency } from '@commutifi/models/Plan';
import { useComponentIntl } from '../../locales';

/**
 * Return the cost frequency suffix/prefix based on specs:
 * 
 * If plan has canBuyMany and frequency = monthly
 *   display: each per month
 * If plan.costType is free
 *   display: Free
 * If plan.costType is variable
 *   display: Variable
 * if plan.costType is singular
 *   3.1. If bookingType is recurrent
 *   3.1.1. frequency yearly: $x per year
 *   3.1.2. frequency monthly: $x per month
 *   3.2. If bookingType is fixed/singular
 *   3.2.1. frequency daily: $x per day
 *   3.2.2. frequency per trip: $x per trip
 *   3.3. If bookingType is standard or unique
 *     display: $x

 * @param cost - cost object
 * @param options - options object
 * @param   bookingType - booking type
 * @param   canBuyMany - can buy many plans (quantity available)
 * @returns 
 */
export function FrequencyDisplay(t0) {
  const $ = _c(27);
  const {
    frequency,
    bookingType,
    canBuyMany
  } = t0;
  const intl = useComponentIntl("FrequencyDisplay");
  let t1;
  if ($[0] !== canBuyMany || $[1] !== intl) {
    t1 = canBuyMany ? <>{intl.formatMessage({
        id: "cost.types.each"
      })} </> : "";
    $[0] = canBuyMany;
    $[1] = intl;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const perUnitText = t1;
  let t2;
  if ($[3] !== intl) {
    t2 = intl.formatMessage({
      id: "cost.frequencies.perTrip"
    });
    $[3] = intl;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== intl) {
    t3 = intl.formatMessage({
      id: "cost.frequencies.perDay"
    });
    $[5] = intl;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== intl) {
    t4 = intl.formatMessage({
      id: "cost.frequencies.perMonth"
    });
    $[7] = intl;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== intl) {
    t5 = intl.formatMessage({
      id: "cost.frequencies.perYear"
    });
    $[9] = intl;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
    t6 = {
      [PlanFrequency.PER_TRIP]: t2,
      [PlanFrequency.DAILY]: t3,
      [PlanFrequency.MONTHLY]: t4,
      [PlanFrequency.YEARLY]: t5
    };
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const costFrequencyMapping = t6;
  const costFrequency = frequency && costFrequencyMapping[frequency] ? costFrequencyMapping[frequency] : undefined;
  switch (bookingType || "") {
    case PlanBookingType.STANDARD:
    case PlanBookingType.UNIQUE:
      {
        let t7;
        if ($[16] !== intl) {
          t7 = intl.formatMessage({
            id: "cost.frequencies.unique"
          });
          $[16] = intl;
          $[17] = t7;
        } else {
          t7 = $[17];
        }
        return t7;
      }
    case PlanBookingType.RECURRENT:
      {
        let t7;
        if ($[18] !== costFrequency || $[19] !== perUnitText) {
          t7 = <>{perUnitText}{costFrequency}</>;
          $[18] = costFrequency;
          $[19] = perUnitText;
          $[20] = t7;
        } else {
          t7 = $[20];
        }
        return t7;
      }
    case PlanBookingType.SINGULAR:
      {
        let t7;
        if ($[21] !== costFrequency || $[22] !== perUnitText) {
          t7 = <>{perUnitText}{costFrequency}</>;
          $[21] = costFrequency;
          $[22] = perUnitText;
          $[23] = t7;
        } else {
          t7 = $[23];
        }
        return t7;
      }
    case "":
    default:
      {
        let t7;
        if ($[24] !== costFrequency || $[25] !== perUnitText) {
          t7 = <>{perUnitText}{costFrequency}</>;
          $[24] = costFrequency;
          $[25] = perUnitText;
          $[26] = t7;
        } else {
          t7 = $[26];
        }
        return t7;
      }
  }
}
interface CostFrequencyProps {
  frequency: PlanFrequency | null | undefined;
  bookingType?: PlanBookingType | null;
  canBuyMany?: boolean;
}